import ReportModal from '@/components/modal/ReportModal.vue'
import { useModalSlot } from 'vue-final-modal'
import { useCustomModal } from '~/modalHelper'

interface Params {
  slug: string
  type: string
}

const getReportModalConfig = (params: Params) => ({
  attrs: {
    modalId: 'report',
    title: 'Signaler ce contenu',
    clickToClose: false,
  },
  slots: {
    default: useModalSlot({
      component: ReportModal,
      attrs: params,
    }),
  },
})

export const getReportModal = (params: Params) =>
  useCustomModal(getReportModalConfig(params))
